import React from 'react'
import VideoIcon from '../../elements/icons/VideoIcon'
import AudioIcon from '../../elements/icons/AudioIcon'
import TextIcon from '../../elements/icons/TextIcon'
import { slugify, transactionTimeStamp } from '../../../utils'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import TrashIcon from '../../elements/icons/TrashIcon'
import ArrowDownTrayIcon from '../../elements/icons/ArrowDownTrayIcon'
import PhotoIcon from '../../elements/icons/PhotoIcon'
import CopyToClipboard from 'react-copy-to-clipboard'
import { SET_SUCCESS } from '../../../store/types'
import CopyIcon from '../../elements/icons/CopyIcon'
import { useDispatch } from 'react-redux'

const DownloadableCard = ({downloadable, openDownloadable, deleteDownloadable}) => {
    const dispatch = useDispatch()
    const handleDownload = async() => {
        // URL of the file to download
        const fileUrl = downloadable.documentUrl;
        const fileName = slugify(downloadable.name); // Optional custom filename
    
        try {
            // Fetch the file as a blob
            const response = await fetch(fileUrl);
      
            if (!response.ok) {
              throw new Error('Failed to fetch file');
            }
      
            const blob = await response.blob();
      
            // Create a blob URL
            const blobUrl = URL.createObjectURL(blob);
      
            // Create an anchor element
            const anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.download = fileName;
      
            // Append and trigger the download
            document.body.appendChild(anchor);
            anchor.click();
      
            // Cleanup
            anchor.remove();
            URL.revokeObjectURL(blobUrl);
          } catch (error) {
            console.error('Error downloading file:', error);
          }
      
    };
    return (
        <div className='w-full'>
            <div className='w-full bg-gray-50 flex items-center justify-center relative h-[200px]'
                style={{
                    backgroundImage: downloadable.documentType === 'IMAGE' ? `url(${downloadable.documentUrl})` : '',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }} 
            >
                {downloadable.documentType === 'VIDEO' && <VideoIcon className={`w-8 h-8 text-gray-500`} />}
                {downloadable.documentType === 'AUDIO' && <AudioIcon className={`w-8 h-8 text-gray-500`} />}
                {/* {downloadable.documentType === 'IMAGE' && <PhotoIcon className={`w-8 h-8 text-gray-500`} />} */}
                {(downloadable.documentType === 'TEXT' || downloadable.documentType === 'DOCUMENT')  && <TextIcon className={`w-8 h-8 text-gray-500`} />}
                {downloadable.hidden && <span className='rounded p-1 bg-yellow-200 bg-opacity-50 text-yellow-900 text-xs font-[500] font-sofia-pro absolute top-[10px] right-[10px]'>hidden</span>}
            </div>

            <div className='p-[10px] mt-[10px]'>
                <p className='text-[15px] mb-[10px] font-[550]'>{downloadable?.name}</p>
                <p className='text-[13px] mb-[10px]'>{downloadable.description.substr(0, 150)}{downloadable.description.length > 150 && '...'}</p>
                <div className='flex items-center gap-x-[10px] mb-[10px]'>
                    {downloadable.documentType === 'VIDEO' && <VideoIcon className={`w-5 h-5 text-gray-500`} />}
                    {downloadable.documentType === 'AUDIO' && <AudioIcon className={`w-5 h-5 text-gray-500`} />}
                    {downloadable.documentType === 'IMAGE' && <PhotoIcon className={`w-5 h-5 text-gray-500`} />}
                    {downloadable.documentType === 'DOCUMENT'  && <TextIcon className={`w-5 h-5 text-gray-500`} />}
                    
                    <p className='capitalize text-sm'>{downloadable.documentType.toLowerCase()}</p>
                </div>
                <p className='text-[13px] mb-[10px]'>Created by <span className='font-[550]'>{downloadable.createdBy?.name}</span>, {transactionTimeStamp(downloadable.createdAt).date}</p>
                <p className='text-[13px] mb-[10px]'>Available for <span className='capitalize'>{downloadable.accessType.join(', ').toLowerCase()}</span></p>
                
                <div className='w-full flex items-center justify-between gap-x-[10px]'>
                    <label className="block text-xs font-medium text-gray-700 font-sofia-pro">Document URL</label>
                    <CopyToClipboard text={downloadable.documentUrl}
                        onCopy={() =>  dispatch({
                            type: SET_SUCCESS,
                            payload: `${downloadable?.name} url copied to clipboard`
                        })}>
                        <button className='text-xs p-1 bg-gray-100 rounded flex items-center justify-center gap-x-[5px] transition duration-200 hover:bg-gray-200'><CopyIcon className={`w-4 h-4 text-gray-500`}/> Copy to clipboard</button>
                    </CopyToClipboard>
                </div>

                <p className='text-vcm-purple text-xs w-[99%] truncate'>{downloadable.documentUrl}</p>
                
                <div className='flex items-center justify-between mt-[20px]'>
                    <button onClick={()=>{openDownloadable()}} className='text-sm flex flex-row items-center gap-x-[5px] text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit  <ArrowIcon className={`w-4 h-4`} /></button> 
                    <div className='flex flex-row-reverse gap-x-[5px]'>
                        <button onClick={()=>{deleteDownloadable()}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                            <TrashIcon className={`w-5 h-5`} />
                        </button>
                        <button onClick={()=>{handleDownload()}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                            <ArrowDownTrayIcon className={`w-5 h-5`} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DownloadableCard